import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from "tabler-react";
import { mapActions } from "../../store/actions";

const El = (props) => (
  <div className="input-group date-picker-with-icon">
    <input
      type="text"
      className="form-control"
      placeholder={props.dateTxt}
      onClick={props.onClick}
      value={props.value}
    />
    <span className="input-group-append" onClick={props.onClick}>
      <Icon prefix="fe" className="btn btn-secondary" name="calendar" />
    </span>
  </div>
);

function DatePickerWithIcon(props) {
  const { txt, name, clearFilters, value } = props;
  const [newDate, changeDate] = useState(value);

  useEffect(() => {
    if (clearFilters === true && value === null) {
      changeDate(null);
      props.getDate({ date: null, name: props.name });
      props.clearMapFilters(false);
    } else {
      changeDate(value);
    }
  }, [clearFilters, value, props]);

  const handleChange = (date) => {
    changeDate(date);
    props.getDate({ date: date, name: props.name });
  };

  return (
    <DatePicker
      name={name}
      className="form-control"
      selected={newDate}
      onChange={handleChange}
      customInput={<El dateTxt={txt} />}
      // onChange={date => setStartDate(date)}
      isClearable
      dateFormat="yyyy/MM/dd"
      minDate={props.min}
      // maxDate={new Date()}
      // showDisabledMonthNavigation
    />
  );
}

function mapStateToProps(state) {
  const { clearFilters } = state.map;
  return {
    clearFilters,
  };
}

const mapDispatchToProps = {
  clearMapFilters: mapActions.clearMapFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerWithIcon);
